import { render } from "./MaterialType.vue?vue&type=template&id=435636b6&scoped=true"
import script from "./MaterialType.vue?vue&type=script&lang=js"
export * from "./MaterialType.vue?vue&type=script&lang=js"

import "./MaterialType.vue?vue&type=style&index=0&id=435636b6&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435636b6"]])

export default __exports__